import gettext from '@sdk/lang/gettext';

import locationGraySvg from '../../assets/svg/UI/location-gray.svg';
import locationBlueSvg from '../../assets/svg/UI/location-blue.svg';

import templateUrl from './timeclockLocationComponent.html';
import clockInOutMapUrl from './clockInOutMap.html';

const componentInstances = [];

export default {
  templateUrl,
  bindings: {
    clockInCoordinates: '<?',
    clockOutCoordinates: '<?',
    locationId: '<',
  },
  controllerAs: 'ctrl',
  controller: class {
    clockInOutMapUrl = clockInOutMapUrl;
    viewLocationsOnTheMapTooltip = gettext('View locations on the map');

    constructor(GoogleMapsService, $scope) {
      'ngInject';

      Object.assign(this, { GoogleMapsService, $scope });
    }

    $onInit() {
      componentInstances.push(this);
      this.$scope.$on('timeclock-map-close', this.closeMap);
    }

    $onDestroy() {
      const index = componentInstances.findIndex((i) => i === this);
      if (index >= 0) {
        componentInstances.splice(index, 1);
      }
    }

    loadMaps() {
      this.GoogleMapsService.load();
    }

    getPinImage(isOpen) {
      return isOpen ? locationBlueSvg : locationGraySvg;
    }

    closeMap = () => {
      if (this.mapPopupOpen) {
        this.mapPopupOpen = false;
      }
    };

    toggleMap() {
      this.mapPopupOpen = !this.mapPopupOpen;

      if (this.mapPopupOpen) {
        componentInstances.forEach((i) => i !== this && i.closeMap());
      }
    }
  },
};
